import { render, staticRenderFns } from "./TradPlayer.vue?vue&type=template&id=212dd090"
import script from "./TradPlayer.vue?vue&type=script&lang=js"
export * from "./TradPlayer.vue?vue&type=script&lang=js"
import style0 from "./TradPlayer.vue?vue&type=style&index=0&id=212dd090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports